import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UserService } from '../../../../common/services/User.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { Observable } from 'rxjs/Rx';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { OrganizeService } from '../../../../common/services/Organize.service';
import { GroupService } from '../../../../common/services/Group.service';
import { FieldService } from '../../../../common/services/Field.service';
import * as _ from 'lodash';
import { SearchService } from '../../../../common/services/Search.service';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from '../../../../common/services/Socket.service';
import { CommentService } from '../../../../common/services/Comment.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { CommonService } from '../../../../common/services/Common.service';
import { environment } from 'environments/environment';
import { ExportService } from '../../../../common/services/Export.service';
import { AssignList, AssignType, CustomerConst } from './customer.const';
import { UserSharedService } from './UserSharedService';
import { BaseListComponent } from '../../../../components/base-list.component';
import { ContactService } from '../../../../common/services/Contact.service';
import { importResponseTemplate } from '../../../../common/conversations/import.response';
import { CommonSettingsService } from '../../../../common/share-data/common.setting.service';
import { SharedUserService } from '../../../../common/share-data/user.service';
import { Role } from '../setting/expert/expert.const';

@Component({
  moduleId: module.id,
  selector: 'customer',
  templateUrl: './customer.component.html',
  styleUrls: ['../../../../../css/fuck.css', './customer.css'],
  providers: [
    UserService,
    TicketService,
    EvsAddressService,
    OrganizeService,
    GroupService,
    FieldService,
    SearchService,
    CommentService,
    UploadService,
    CommonService,
    ContactService,
  ],
})
export class CustomerComponent extends BaseListComponent {
  @ViewChild('filterTemplate') filterTemplate: ElementRef;
  @ViewChild('templateImport') templateImport: ElementRef;

  public filterSearchKey = 'search_user';
  public active_fields: any = [];
  public data_search: any = {};
  public choice: any = {};
  public modelFilter: any = {};
  public model: any = {
    sub_and_or: 'and',
    main_and_or: 'and',
  };
  public fields = [];
  public allAgent: any = [];
  public allStatus: any = [];
  public allCity: any = [];
  public allDistrict: any = [];
  public allGroup: any = [];
  public allOrganize: any = [];
  public tab = 'user';
  public placeholder = 'Tìm kiếm theo chủ đề';
  public detailTicket: any = {};
  public listFilter: any = [];
  public selectFilter: any = 'Bộ lọc mới';
  public filterHtml: any = {};
  public filterModal: any = {};
  public filter_id: any;

  public exportData: any = [];
  public listToExport: any = [];

  /************IMPORT */
  public isImport = false;
  public step = 1;
  public keys: any = [];
  public file_out: any;
  public fieldsImport: any = [];
  public modelImport: any = {};
  public headers: any = [{ id: '', text: '' }];
  public mapping: any = {};
  public file_import: any;
  public key: any;
  public exec_import: any = 'create';
  public complete_load = 50;
  public assignList = [];
  public assignType: AssignType = AssignType.All;
  public displayFilterForm = false;
  public editFilterId: any;
  public displayFilter = false;
  public importRes: any = null;
  private customParams: any = {};
  private _filterChecked: any = null;
  public exportFields: any = [];
  public allField: any = [];
  /************IMPORT */

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private searchService: SearchService,
    private socketService: SocketService,
    private sharedService: UserSharedService,
    private contactService: ContactService,
    private addressService: EvsAddressService,
    private sharedCommonSettings: CommonSettingsService,
    private commonService: CommonService,
    private sharedUserService: SharedUserService
  ) {
    super(changeDetector, toastr, modalService);
    switch (this.user.role) {
      case Role.Agent:
        this.assignList = [
          {
            id: AssignType.All,
            title: 'Tất cả',
          },
        ];
        break;
      case Role.TeamLeader:
        this.assignType = AssignType.MyGroup;
        this.assignList = [
          {
            id: AssignType.MyGroup,
            title: 'Bộ phận của tôi',
          },
          {
            id: AssignType.Me,
            title: 'Của tôi',
          },
        ];
        break;
      default:
        this.assignList = [
          {
            id: AssignType.All,
            title: 'Tất cả',
          },
          {
            id: AssignType.MyOrganization,
            title: 'Tổ chức của tôi',
          },
        ];
        break;
    }

    this.sharedService.onUserCreate.subscribe(data => {
      console.log('handleEvent |============>>>', data);
      // TODO: need to improve performance
      this.data.unshift(data);
    });
    this.sharedService.onUserUpdated.subscribe(data => {
      setTimeout(async () => {
        await this.loadData();
      }, 3000);
    });
  }

  public get filterChecked() {
    return this._filterChecked ? this._filterChecked._id : null;
  }

  public set filterChecked(value) {
    this._filterChecked = this.filterChecked === value._id ? null : value;
    this.choiceFilter(this._filterChecked);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    this.is_loading = true;
    await this.initCities();
    await this.initGroups();
    await this.initOrganizes();
    this.allField = await this.sharedCommonSettings.getAllUserFields();
    this.loadFilter();
    // @ts-ignore
    const { user_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    const displayColumns = CustomerConst.displayColumns(this.allField);
    if (user_table_columns) {
      const saveDisplayColumns = JSON.parse(user_table_columns);
      this.displayColumns = displayColumns.map(d => {
        try {
          const sD = saveDisplayColumns.find(sd => d.field === sd.field);
          if (sD) {
            d.display = sD.display;
          }
          return d;
        } catch (e) {
          return d;
        }
      });
    } else {
      this.displayColumns = displayColumns;
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          user_table_columns: JSON.stringify(this.displayColumns),
        })
        .toPromise();
    }
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
    await this.loadData();
  }

  async changedOptionView(data) {
    this.displayColumns = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        user_table_columns: JSON.stringify(this.displayColumns),
      })
      .toPromise();
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
  }

  async initCities() {
    const res = await this.sharedCommonSettings.getAllCities();
    const cityList = [];
    res.forEach((c: any) => {
      cityList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allCity = cityList;
  }

  initDistricts(res) {
    if (res.status == 200 && !res.error) {
      const districtList = [];
      res.data.districts.forEach((c: any) => {
        districtList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allDistrict = districtList;
    }
  }

  async initOrganizes() {
    const res = await this.sharedCommonSettings.getAllOrganize();
    const organizeList = [];
    res.forEach((c: any) => {
      organizeList.push({
        text: c.name,
        id: c.organize_id,
      });
    });
    this.allOrganize = organizeList;
  }

  async initGroups() {
    const res = await this.sharedUserService.getCustomerGroups();
    const groupList = [];
    res.forEach((c: any) => {
      groupList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allGroup = groupList;
  }
  choiceFilter(filter?: any) {
    this.selectFilter = 'Bộ lọc mới';
    this.filter_id = null;
    if (filter) {
      this.filter_id = filter._id;
      this.selectFilter = filter.name;
      this.filterHtml = JSON.parse(filter.data);
      this.filterModal = {
        main_and_or: filter.main_and_or,
        sub_and_or: filter.sub_and_or,
      };
    } else {
      this.filterHtml = {};
      this.filterModal = {};
    }
  }

  deleteFilter(filter: any, event) {
    event.stopPropagation();

    const y = confirm('Bạn có muốn xóa bộ lọc này không?');
    if (y) {
      this.searchService.deleteFilter(filter._id).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadFilter();
          this.toastr.success('Xóa bộ lọc thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          if (this.editFilterId === filter._id) {
            this.editFilterId = null;
          }
        }
      });
    }
  }

  getFileImportContactExample() {
    this.contactService.getFileImportContactExample();
  }

  changeFileImportContact($event) {
    const files = $event.srcElement.files;
    this.modelImport.file = files[0];
  }
  changeGroupImport($event) {
    this.modelImport.group_id = $event.target.value;
  }

  importFile() {
    const file = this.modelImport.file;
    if (!file) {
      return this.toastr.error('Vui lòng upload file khách hàng', 'Lỗi', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    this.isImport = true;
    const payload = {
      group_id: this.modelImport.group_id,
      tags: this.modelImport.tags
        ? typeof this.modelImport.tags === 'string'
          ? this.modelImport.tags
          : this.modelImport.tags.map(t => t.displayValue).join(',')
        : undefined,
    };
    this.contactService.importContactWithFile(file, payload).then(
      (res: any) => {
        this.importRes = importResponseTemplate(res.data);
        this.isImport = false;
        this.loadData();
      },
      err => {
        this.throwError(err.message);
      }
    );
  }

  openModalImport() {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modelImport = {};
    this.openModal(this.templateImport, config);
  }

  openModalFilter() {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.openModal(this.filterTemplate, config);
  }
  async buildPayload() {
    const data = this.data_search;
    let active_fields = this.active_fields;
    if (active_fields.includes('dob_month')) {
      data.dob_month = data.dob_month.map(x => {
        if (!x.hasOwnProperty('bool')) {
          const month = x.match_phrase.dob_month;

          return {
            wildcard: {
              dob_string: {
                value: `????-${month}-*`,
              },
            },
          };
        }

        const month = x.bool.must_not.match_phrase.dob_month;

        return {
          bool: {
            must_not: {
              wildcard: {
                dob_string: {
                  value: `????-${month}-*`,
                },
              },
            },
          },
        };
      });
    }

    let condition = {};
    const arr = [];
    active_fields = _.union(active_fields);
    active_fields.forEach(field => {
      const sub_condition = {};
      if (this.model.sub_and_or == 'and') {
        sub_condition['must'] = data[field];
      } else {
        sub_condition['should'] = data[field];
      }

      arr.push({
        bool: sub_condition,
      });
    });

    if (arr.length > 0) {
      if (this.model.main_and_or == 'and') {
        condition['must'] = arr;
      } else {
        condition['should'] = arr;
      }
    } else {
      condition = {};
    }
    switch (this.assignType) {
      case AssignType.MyOrganization:
        if (condition['must']) {
          condition['must'] = [
            ...condition['must'],
            {
              term: {
                organize_id: this.user.organize_id,
              },
            },
          ];
        } else {
          condition['must'] = [
            {
              term: {
                organize_id: this.user.organize_id,
              },
            },
          ];
        }
        break;
      case AssignType.Me: {
        const search = {
          bool: {
            should: [
              {
                term: {
                  user_id: this.user._id,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        if (condition['must']) {
          condition['must'] = [...condition['must'], search];
        } else {
          condition['must'] = [search];
        }
        break;
      }
    }
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(active_fields),
      type: this.tab,
      label: this.model.main_and_or,
      sub_label: this.model.sub_and_or,
      keyword: this.model.keyword,
      ...this.customParams,
      force_search: 'customer',
    };
    body['offset'] = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    body['limit'] = this.page_size;
    return body;
  }
  async loadData() {
    const body = await this.buildPayload();
    this.data = [];
    let districtList = [];
    this.searchService.all(body).subscribe(async res => {
      if (!res.error && res.status == 200) {
        this.data = res.data.list;
        this.listToExport = [];
        if (this.tab == 'user') {
          this.data = _.map(this.data, e => {
            if (e.group_id) {
              const group = _.find(this.allGroup, { id: parseInt(e.group_id) });
              if (group) {
                e['group'] = group;
              }
            }
            if (e.organize_id) {
              const org = _.find(this.allOrganize, {
                id: parseInt(e.organize_id),
              });
              if (org) {
                e['organize'] = org;
              }
            }
            if (e.city_id) {
              const city = _.find(this.allCity, { id: parseInt(e.city_id) });
              if (city) {
                e['city'] = city;
              }
            }
            if (e.district_id) {
              districtList.push(e.district_id);
            }
            e.display_updated_at = CustomerConst.displayTimeColumns(e.updated_at);
            e.display_name = CustomerConst.displayNameColumns(e, this.user);
            e.display_phone = CustomerConst.displayPhoneColumns(e, this.user);
            e.display_email = CustomerConst.displayEmailColumns(e);
            e.display_organize = CustomerConst.displayOrganizeColumns(e);
            e.display_group = CustomerConst.displayGroupColumns(e);
            e.display_city = CustomerConst.displayCityColumns(e);
            e.display_district = CustomerConst.displayDistrictColumns(e);
            e.display_source = CustomerConst.displaySourceColumns(e);
            e.display_created_at = CustomerConst.displayTimeColumns(e.created_at);
            e.display_customer_type = CustomerConst.displayCustomerTypeColumns(e);
            e.display_facebook = CustomerConst.displayFacebookColumns(e);
            e.display_sub_phone = CustomerConst.displaySubPhoneColumns(e, this.user);
            e.display_sub_email = CustomerConst.displaySubEmailColumns(e);
            e.display_gender = CustomerConst.displayGenderColumns(e);
            e.display_dob = CustomerConst.displayDob(e);
            this.allField.forEach(t => {
              e['display_' + t.key] = CustomerConst.displayFieldColumn(e, t);
            });
            return e;
          });
          if (districtList.length > 0) {
            await this.addressService.getDistrict({ districts: districtList }).subscribe(res => {
              if (res.status == 200 && !res.error) {
                this.initDistricts(res);
                this.data.map(value => {
                  if (value.district_id) {
                    value.district = this.allDistrict.find(district => district.id == value.district_id);
                    value.display_district = value.district ? value.district.text : 'Chưa xác định';
                  }
                  return value;
                });
              }
            });
          }

          this.listToExport = _.map(this.listToExport, e => {
            if (e.group_id) {
              const group = _.find(this.allGroup, { id: parseInt(e.group_id) });
              if (group) {
                e['group'] = group;
              }
            }
            if (e.organize_id) {
              const org = _.find(this.allOrganize, {
                id: parseInt(e.organize_id),
              });
              if (org) {
                e['organize'] = org;
              }
            }
            if (e.city_id) {
              const city = _.find(this.allCity, { id: parseInt(e.city_id) });
              if (city) {
                e['city'] = city;
              }
            }
            if (e.district_id) {
              const district = _.find(this.allDistrict, { id: parseInt(e.district_id) });
              if (district) {
                e['district'] = district;
              }
            }
            return e;
          });
        } else if (this.tab == 'organize') {
          this.data = _.map(this.data, e => {
            if (e.tags) {
              e.tags = e.tags.split(',');
            }
            return e;
          });
        }

        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      }
    });
  }

  loadFilter() {
    this.searchService.listFilter({ type: this.tab }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.listFilter = res.data.data;
      }
    });
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  async export() {
    const body = await this.buildPayload();
    console.log(this.exportFields, 'this.exportFields');
    this.contactService.exports({}, { ...body, fields: this.exportFields });
  }

  async onChangeAssign(assignType: any) {
    this.assignType = assignType;
    this.currentPage = 1;
    await this.loadData();
  }

  cancel() {
    this.displayFilterForm = false;
    this.editFilterId = null;
  }

  toggleFilter() {
    this.displayFilter = !this.displayFilter;
  }

  sort(value) {
    this.customParams = {
      ...this.customParams,
      sort_by: `${value.key}:${value.type}`,
    };

    this.loadData();
  }

  loadDataByFilter(data) {
    this.model.main_and_or = data.main_and_or || 'and';
    this.model.sub_and_or = data.sub_and_or || 'and';
    this.data_search = data.data_search || {};
    this.active_fields = data.active_fields || [];
    this.loadData();
  }

  onSaveFilter(data) {
    const payload = {
      data: JSON.stringify(data.data_save),
      main_and_or: data.main_and_or,
      sub_and_or: data.sub_and_or,
      name: data.name,
      type: 'user',
      type_filter: 'cus_user',
    };
    if (!payload.name || (payload.name && payload.name.trim() === '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên bộ lọc không được bỏ trống!',
      };
      return;
    }
    this.searchService.createFilter(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadFilter();
          this.choiceFilter(res.data);
          this.filterChecked = res.data;
          this.closeModal();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  endLoading() {
    this.is_loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/customer/customer.component.ts